import {
  Avatar,
  Badge,
  Box,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import Header from "../../components/header";
import { HeaderSection, ListContainer } from "../style";
import { useTheme } from "styled-components";
import { NotificationWrapper } from "./style";
import { CustomButton } from "../../globalStyle";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptJoinTeamLoaderSelector,
  notificationListSelector,
  notificationLoaderSelector,
  rejectJoinTeamLoaderSelector,
} from "../../store/metadata/selector";
import { notificationType } from "../../store/metadata/types";
import { MetaDataSagaActions } from "../../store/metadata/sagas";
import { renderNotificationButtonText } from "../../utils/constants";
import { formatCreatedDate } from "../../utils/helpers";
import { useEffect, useState } from "react";
import CreateBoardModal from "../../components/modals/createBoardModal";
import { convertHtmlToText } from "../../components/notificationPopover";
import routeConstant from "../../utils/routeConstant";
import {AdDrawerStyledButton} from "../../components/commonComponents/adDetails/style";
import {NavigatePrevIcon} from "../../assets/Icons";
import {useNavigate} from "react-router-dom";

const content = {
  tabTitle: "Notifications",
  tabSubTitle: "All new updates, you receive here!",
};

const Notification = () => {
  const theme = useTheme();
  const notificationList = useSelector(notificationListSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(notificationLoaderSelector);
  const [loadingNotifications, setLoadingNotifications] = useState<{
    id: null | string;
    type: string;
  }>({ id: null, type: "" });

  const handleAccept = (
    notificationId: string,
    teamId: string,
    seatId: string
  ) => {
    setLoadingNotifications({ id: notificationId, type: "ACCEPTED" });
    return new Promise<void>((resolve, reject) => {
      dispatch(
        MetaDataSagaActions.joinTeamMemberSeatSaga({
          notificationId,
          teamId,
          seatId,
          status: "ACCEPTED",
          resolve,
          reject,
        })
      );
    })
      .then(() => {
        setLoadingNotifications({ id: null, type: "" });
        dispatch(MetaDataSagaActions.notificationList());
      })
      .catch((error) => {
        console.error("Accept failed:", error);
        setLoadingNotifications({ id: null, type: "" });
      });
  };

  const handleDecline = (
    notificationId: string,
    teamId: string,
    seatId: string
  ) => {
    setLoadingNotifications({ id: notificationId, type: "REJECTED" });
    return new Promise<void>((resolve, reject) => {
      dispatch(
        MetaDataSagaActions.joinTeamMemberSeatSaga({
          notificationId,
          teamId,
          seatId,
          status: "REJECTED",
          resolve,
          reject,
        })
      );
    })
      .then(() => {
        setLoadingNotifications({ id: null, type: "" });
        dispatch(MetaDataSagaActions.notificationList());
      })
      .catch((error) => {
        console.error("Decline failed:", error);
        setLoadingNotifications({ id: null, type: "" });
      });
  };

  useEffect(() => {
    dispatch(MetaDataSagaActions.notificationList());
  }, []);

  return (
    <>
      <HeaderSection>
        <Header content={content} />
        <ListContainer>
            <AdDrawerStyledButton onClick={() => navigate(-1)}>
                <NavigatePrevIcon />
                Back
            </AdDrawerStyledButton>
          <NotificationWrapper>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {notificationList?.map(
                  (notification: notificationType, index: number) => {
                    const titleText = convertHtmlToText(notification.title);
                    return (
                      <div
                        key={notification._id}
                        style={{
                          borderBottom: `1px solid ${theme.colors.whisper}`,
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            position: "relative",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              margin: "4.25rem 0.75rem 1.25rem 1.125rem",
                              position: "relative",
                            }}
                          >
                            {!notification.read && (
                              <Badge
                                variant="dot"
                                sx={{
                                  ".MuiBadge-badge": {
                                    position: "absolute",
                                    backgroundColor: `${theme.colors.radicalRed}`,
                                    height: "0.5rem",
                                    minWidth: "0.5rem",
                                    top: "-1.2rem",
                                  },
                                }}
                              />
                            )}
                          </div>

                          <Avatar
                            src={
                              notification?.imageUrl ||
                              "assests/images/user-image.png"
                            }
                            sx={{
                              width: "4rem",
                              height: "4rem",
                              borderRadius: "50%",
                            }}
                          />
                          <Stack
                            sx={{
                              marginLeft: "0.938rem",
                              gap: "0.625rem",
                              width: "75%",
                              flexWrap: "wrap",
                            }}
                          >
                            <Typography
                              fontSize="1rem"
                              fontWeight="600"
                              color={theme.colors.black2}
                              lineHeight="1.524rem"
                            >
                              {titleText}
                            </Typography>
                            <Typography
                              fontSize="0.8rem"
                              fontWeight="400"
                              color={theme.colors.gray1}
                              lineHeight="1.524rem"
                            >
                              {notification.description}
                            </Typography>
                          </Stack>
                          <Typography
                            fontSize="0.8rem"
                            fontWeight="500"
                            whiteSpace="nowrap"
                            color={theme.colors.black2}
                            lineHeight="1.524rem"
                            alignSelf="start"
                            marginTop="0.7rem"
                          >
                            {formatCreatedDate(notification?.createdAt ?? "")}
                          </Typography>
                        </Stack>
                        {notification.type === renderNotificationButtonText && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              gap: "0.625rem",
                              marginLeft: "6.6rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <CustomButton
                              key={notification._id}
                              sx={{
                                padding: "0.375rem 0.938rem",
                                border: `1px solid ${theme.colors.border1}`,
                                background: `${theme.colors.white}`,
                                color: `${theme.colors.gray1}`,
                                borderRadius: "3.125rem",
                              }}
                              disabled={
                                loadingNotifications.type === "REJECTED" &&
                                loadingNotifications.id === notification._id
                              }
                              startIcon={
                                loadingNotifications.type === "REJECTED" &&
                                loadingNotifications.id ===
                                  notification._id && (
                                  <CircularProgress size={22} color="inherit" />
                                )
                              }
                              onClick={() =>
                                handleDecline(
                                  notification._id,
                                  notification.teamId,
                                  notification?.seatId
                                )
                              }
                            >
                              Decline
                            </CustomButton>
                            <CustomButton
                              key={notification._id}
                              style={{
                                padding: "0.375rem 0.938rem",
                                border: `1px solid ${theme.colors.border1}`,
                                background: `${theme.colors.backgroundPrimary}`,
                                color: `${theme.colors.white}`,
                                borderRadius: "3.125rem",
                              }}
                              disabled={
                                loadingNotifications.type === "ACCEPTED" &&
                                loadingNotifications.id === notification._id
                              }
                              startIcon={
                                loadingNotifications.type === "ACCEPTED" &&
                                loadingNotifications.id ===
                                  notification._id && (
                                  <CircularProgress size={22} color="inherit" />
                                )
                              }
                              onClick={() =>
                                handleAccept(
                                  notification._id,
                                  notification.teamId,
                                  notification?.seatId
                                )
                              }
                            >
                              Accept
                            </CustomButton>
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
              </>
            )}
          </NotificationWrapper>
        </ListContainer>
      </HeaderSection>
      <CreateBoardModal />
    </>
  );
};

export default Notification;
